goog.provide('el8.appchart.dialog.ordermed.document');

goog.require('el8.appchart.dialog.ordermed.base');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.appservice.notifier');
goog.require('el8.ptdata.base');
goog.require('el8.uiwidget.base');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.confirm');
goog.require('el8.uiwidget.Dialog');
goog.require('el8.uiwidget.NewActionsMenu');
goog.require('el8.util.consts');
goog.require('el8.service.infoField');
goog.require('el8.service.tz');


el8.appchart.dialog.ordermed.document = (function() {

    var isInit = false;
    var addToNote = true;

    var that = {};

    var container = null;
    var dialog = null;
    var model = null;

    var saveBtn = null,
        saveAndAddBtn = null,
        cancelBtn = null,
        prescriberInputField = null,
        medicationInputField = null,
        directionsInputField = null,
        indicationInputField = null,
        quantityInputField = null,
        quantityUnitsInputField = null,
        authRefillsInputField = null,
        startDateInputField = null,
        addToPermanentCheckbox = null,
        medsListSelectField = null,
        rxTypeSelectField = null,
        notesInputField = null,
        detailsTrigger = null;
    var medicationField = null;
    var saveCallbackFn = null;
    var reloadVitalsFn = null;

    function init() {

        container = $('#new-document-med-ui');
        dialog = container.el8_simpleInputDialog({
            containerId: 'new-document-med-dialog',
            preferredHeight : 500,
            preferredWidth : 500,
            title: 'Document Med <span class="dialogHeaderNormal">Patient Is On</span>', // XSS OK -KF
            closeElt: null,
            closeFn: function() { hide(); },
            disableTitlebarClose: true
        });

        // ---------------------------
        // Initialize all fields
        // ----------------------------
        saveBtn = container.find('#new-document-med-save-btn');
        saveAndAddBtn = container.find('#new-document-med-save-and-add-btn');
        cancelBtn = container.find('#new-document-med-cancel-btn');

        prescriberInputField = container.find(':input[name="prescriber"]');
        medicationInputField = container.find(':input[name="medication"]');
        directionsInputField = container.find(':input[name="med-directions"]');
        indicationInputField = container.find(':input[name="indication"]');
        quantityInputField = container.find(':input[name="quantity"]');
        quantityUnitsInputField = container.find(':input[name="quantityUnits"]');
        authRefillsInputField = container.find(':input[name="authRefills"]');
        startDateInputField = container.find(':input[name="startDate"]');
        addToPermanentCheckbox = container.find(':input[name="addToPermanentMedList"]');
        medsListSelectField = container.find(':input[name="medsListType"]');
        notesInputField = container.find(':input[name="notes"]');

        rxTypeSelectField = container.find(':input[name="rxType"]');
        detailsTrigger = $('#new-document-med-details-header', container);

        medicationField = el8.service.infoField.addInfoField({
            field: medicationInputField,
            maxLength: el8.util.consts.MAX_MED_LENGTH,
            infoText: 'name and strength...'
        });

        // -------------------------
        // Get the base med order form
        // -------------------------
        that = new el8.appchart.dialog.ordermed.base({
            container: container,
            prescriberField: $('.prescriber-field', container),
            medicationField: medicationField,
            directionsField: el8.service.infoField.addInfoField({
                                field : directionsInputField,
                                maxLength : 100,
                                infoText : 'directions...'
                            }),
            indicationField: el8.service.infoField.addInfoField({
                                field : indicationInputField,
                                maxLength : 50,
                                infoText : 'indication...'
                            }),
            quantityField: el8.service.infoField.addInfoField({
                                field : quantityInputField,
                                maxLength : 15,
                                infoText : '#...'
                            }),
            quantityUnitsField: el8.service.infoField.addInfoField({
                                field : quantityUnitsInputField,
                                maxLength : 20,
                                infoText : 'units...'
                            }),
            authRefillsField: el8.service.infoField.addInfoField({
                                field : authRefillsInputField,
                                maxLength : 10,
                                infoText : ''
                            }),
            startDateField: startDateInputField.el8_datePicker(
                                { maxDate: el8.service.tz.today() },
                                { maxLength: 10, infoText: Date.format }
                            ),
            notesField: el8.service.infoField.addInfoField({
                                field: notesInputField,
                                maxLength: 500,
                                infoText: 'notes..'
                            }),
            orderTypeSelectField: rxTypeSelectField,
            addToPermanentCheckbox: addToPermanentCheckbox,
            medsListSelectField: medsListSelectField,
            patientInfoDiv: $('#new-document-med-cds', container),
            relatedThreadDiv: $('.meds-related-order', container),
            actionsMenu: new el8.uiwidget.NewActionsMenu({
                container: container,
                anchorTop: container,
                menuId: 'new-document-med-actions-menu',
                offsets: {
                    top: 22,
                    left: 5
                }
            }),
            detailsDiv: $('#new-document-med-details', container),
            detailsTrigger: detailsTrigger
        });
        that.init();

        saveBtn.unbind('click').on('click', function(e) {
            doSave();
        });

        saveAndAddBtn.unbind('click').on('click', function(e) {
            doSave(true);
        });

        cancelBtn.unbind('click').on('click', function(e) {
            hide();
        });

        reloadVitalsFn = el8.appchart.dialog.ordermed.util.initPatientVitalsPanel(
            $('.meds-form-pt-vitals', container),
            $('.meds-form-pt-vitals fieldset', container)
        );

        isInit = true;

        return that;
    }

    // ------------------------
    // Activate buttons; define show/hide
    // ------------------------
    function doSave( addAnother ) {

        dialog.disableForms();
        model = that.getMedOrder(model, true);

        var validated = that.validate(model);
        if( !validated.result ) {
            el8.uiwidget.alert( validated.msg );
            dialog.enableForms();
        } else {

            var validatedCds = that.validateCdsInteractions(model,
                function() { dialog.enableForms(); doSave(addAnother); }, // do again
                function() { dialog.enableForms(); },
                'Over-ride Contra-indication & Document'
            );
            if (!validatedCds ) { return; }

            el8.appservice.notifier.notify(model.getNotifyText('SAVE_IN_PROGRESS'));

            el8.ptdata.medOrders.saveItem(model, false, {
                successCb: function() {
                    el8.appservice.notifier.notify(model.getNotifyText('SAVE_COMPLETE'));

                    if(addToNote) {
                        el8.appchart.mgr.notes.addNewOrder(model);
                    }

                    if (saveCallbackFn) {
                        saveCallbackFn(model);
                    }

                    // Save the prescriber before it gets obliterated
                    var prescriberId = model.getPrescribingPhysicianId();

                    dialog.enableForms();
                    hide();

                    if( addAnother === true ) {
                        el8.appchart.dialog.ordermed.document.show({prescriberId: prescriberId});
                    }
                },
                errorCb: function() {
                    el8.appservice.notifier.notify(model.getNotifyText('SAVE_ERROR'));
                    dialog.enableForms();
                }
            });
        }
    }

    function show( spec ) {
        if (!isInit) { init(); }
        that.initForms();

        if (spec) {
            if (spec.order || spec.newOrder) {
                if ((model && !model.isSignedOff()) || medicationField.getVal()) {
                    // If form is already populated, confirm before overwriting
                    el8.uiwidget.confirm('Do you want to replace the contents of the document med form?',
                        function() {
                            model = that.updateForm(spec);
                        });

                // Otherwise, just populate
                } else {
                    model = that.updateForm(spec);
                }
                addToNote = (spec.addToNote !== false);
            }
            if (spec.saveCallbackFn) {
                saveCallbackFn = spec.saveCallbackFn;
            }
            if (spec.prescriberId) {
                that.populatePrescriber(spec.prescriberId);
            }
            dialog.setModal((spec.isModal === true)); // defaults to false
        }
        // If no prescriber specified and we have a staff, default to default physician
        // assigned to that staff
        if (!spec || (spec && !spec.prescriberId)) {
            if (el8.data.currUser.isOfficeStaff()) {
                var defaultPhysicianId = el8.data.currUser.getDefaultPhysicianId();
                if (defaultPhysicianId) {
                    that.populatePrescriber(defaultPhysicianId);
                }
            }
        }

        dialog.show();
        dialog.bindTabListeners(':input[name="rxType"]');
        medicationInputField.focusSelect();

        that.initDetailsDiv(
            function() {
                quantityInputField.focusSelect();
            },
            function() {
                medicationInputField.focusSelect();
            },
            true
        );

        reloadVitalsFn();
    }

    function hide() {
        model = null;
        dialog.unbindTabListeners();
        that.reset();
        dialog.hide();
    }

    return {
        show : show
    };

})();
